// components/misc/Workflow/AddActionNode.js
import React from "react";
import { Handle, Position } from "reactflow";

const AddActionNode = ({ data, isConnectable }) => {

    const handleOnClick = (event) => {
        if (data.onClick) {
            data.onClick(event, data.id);
        }
    }

    const handleStyle = {
        backgroundColor: "black",
        width: "0px",
        height: "0px",
        borderRadius: "50%",
        border: "1px solid #ccc",
        // boxShadow: "0 0 2px rgba(0,0,0,0.2)",
        cursor: "pointer",
    };

    const nodeStyle = {
        borderRadius: "50%",
        width: "20px",
        height: "20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "1px solid #0000FF",
        backgroundColor: "#fff",
        color: "#0000FF",
        fontSize: "10px", // Adjust font size as needed
        lineHeight: "1", // Ensure line height is set to 1
    };

    return (
        <div style={nodeStyle} className="relative cursor-pointer" onClick={handleOnClick}>
            <Handle
                type="target"
                position={Position.Top}
                id="a"
                isConnectable={isConnectable}
                style={handleStyle}
            />
            <Handle
                type="source"
                position={Position.Bottom}
                id="b"
                isConnectable={isConnectable}
                style={handleStyle}
            />
            <div>
            <div style={{ lineHeight: "1" }}>{data.label}</div>
            </div>
        </div>
    );
};

export default AddActionNode;
